module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-meters"
  }, [_c('h2', [_vm._v("电力使用情况")]), _c('filter-chart', {
    attrs: {
      "type": "line",
      "data": _vm.get_data("electricity"),
      "options": _vm.options("耗电量 (千瓦时/天)"),
      "presets": _vm.presets1,
      "current": "floors",
      "height": 600
    }
  }), _c('h2', [_vm._v("水力使用情况")]), _c('filter-chart', {
    attrs: {
      "type": "line",
      "data": _vm.get_data("water"),
      "options": _vm.options("用水量 (吨/天)"),
      "presets": _vm.presets2,
      "current": "all"
    }
  }), _c('h2', [_vm._v("能耗收益")]), _c('filter-chart', {
    attrs: {
      "type": "line",
      "data": _vm.benifits(),
      "options": _vm.options("收益/元"),
      "presets": _vm.presets3,
      "current": "days"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a687567e","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/reports/Meters.vue
// module id = 534
// module chunks = 0